(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-to-use--redesign"] && !Shopify.designMode) return;
  try {
    

(function() {
  const tabsList = document.querySelectorAll(".how-to-use__content-list li")
  if(tabsList?.length > 0) {
    tabsList.forEach((element) => {
      element.addEventListener("mouseenter", (event) => {
        // Updating panel selectors
        const linkList = element.parentNode.querySelectorAll('.how-to-use__content-list--item');
        (linkList || []).forEach((link) => {
          link.classList.remove('active');
        });
        event.target.classList.add("active");

        // Updating content panels
        const blocksList = document.querySelectorAll('.how-to-use__content--item');
        (blocksList || []).forEach((block) => {
          block.classList.remove('active');
        });
          
        const blockToBeShown = document.querySelector(`.how-to-use__content ${event.target.querySelector('a').dataset.target}`);
        // console.log(`Heres the block to be shown with ${event.target.querySelector('a').dataset.target} and DOM element  ${blockToBeShown}`);
        blockToBeShown.classList.add("active");
      })
    })
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews--static"]) return;
  try {
         
    (function(){
      let reviewType = document.querySelector('#reviews').dataset.type;
      if(reviewType == 'api') {
        const $reviewsContainer = $('.stamped-reviews__container');
        const productId = $reviewsContainer.data('productid');

        const settings = {
          "url": "https://stamped.io/api/v2/109231/dashboard/reviews/?productId=" + productId,
          "method": "GET",
          "timeout": 0,
          "headers": {
            "Authorization": "Basic cHVia2V5LTYwMXVXZVZFczRBcDA2NzBMY2dUMVVWZGV2dlRjczprZXktSDNmTWhya1owM1AwOTZkWFA5NjhZMlEydThTOVNh",
            "Content-Type": "application/x-www-form-urlencoded"
          },
        };

        $.ajax(settings)
        .done(function (response) {
          let $html = "";
          const data = response.results;
          let stars = 0;
          for (var i in data){
            const scope = data[i].review;
            $html += '<div class="stamped-review carousel-cell">';
            $html += '<div class="stamped-review__title">'+scope.title+'</div>';
            $html += '<div class="stamped-review__date">'+scope.dateCreated.replaceAll('-', '/').slice(0,10)+'</div>';
            $html += '<div class="stamped-review__stars">';
            for(let i = 0; i < scope.rating; i++){
              $html += '<i class="stamped-fa-star"></i>'
            }      
            $html += '</div>';
            $html += '<div class="review__content">';
            $html += '<div class="stamped-review__text-container">';
            $html += '<div class="stamped-review__description">'+scope.body+'</div>';
            $html += '<div class="stamped-review__author">'+scope.author+'</div>';      
            $html += '</div>';
            $html += '</div>';    
            $html += '</div>';
            stars = stars + scope.rating;
          }
          const summary = $(".stamped-reviews__ratings-summary");
          const average = stars / data.length;
          let $htmlStars = "";
          for(let i = 0; i <= average; i++) {
            $htmlStars += '<i class="stamped-fa-star"></i>'
          }
          summary.find('.stamped-review__rating').text(parseFloat(average).toFixed(1));
          summary.find('.stamped-review__stars').html($htmlStars);
          summary.find('.stamed-reviews_description-based').text(`Based on ${data.length} Reviews`);
          $reviewsContainer.append( $html );
          $reviewsContainer.paginate();
        })
        .catch(e => {
          console.log("error: ", e)
        });
      } 
    })(document);

  } catch(e) { console.error(e); }
})();
})();
